import React from 'react';
import { motion } from 'framer-motion';
import image1 from "../../assets/individual/individual-signup.png";
import image2 from "../../assets/individual/individual-choose.png";
import image3 from "../../assets/individual/individual-learn.png";
import image4 from "../../assets/individual/individual-forums.png";

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.3,
        },
    },
};

const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.7 } },
};

function IndividualAbout() {
    return (
        <section>
            <div className="bg-white py-12">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <motion.div
                        className="mx-auto max-w-5xl lg:text-center flex flex-col justify-center items-center"
                        initial="hidden"
                        animate="visible"
                        variants={containerVariants}
                    >
                        <motion.h2
                            className="text-base font-semibold leading-7 text-blue-100 bg-blue-600 px-3 rounded-lg uppercase mb-4 lg:mb-8"
                            variants={itemVariants}
                        >
                            Key Features
                        </motion.h2>
                        <motion.h1
                            className="lg:text-6xl text-4xl md:text-4xl font-bold tracking-tight text-gray-900 text-center"
                            variants={itemVariants}
                        >
                            How{' '}
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-700 via-blue-800 to-gray-900">
                                It Works
                            </span>
                        </motion.h1>
                        <motion.p
                            className="mt-6 text-md text-gray-700 max-w-3xl text-center"
                            variants={itemVariants}
                        >
                            Discover the exceptional features of our insurance services designed to streamline processes and provide comprehensive coverage for your needs.
                        </motion.p>
                    </motion.div>
                    <motion.div
                        className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-4xl"
                        initial="hidden"
                        animate="visible"
                        variants={containerVariants}
                    >
                        <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-2 lg:gap-y-16">
                            <motion.div className="relative pl-16" variants={itemVariants}>
                                <dt className="text-base font-semibold leading-7 text-gray-900">
                                    <div className="absolute left-0 top-0 flex h-12 w-12 items-center justify-center rounded-lg">
                                        <img src={image1} alt="Sign up" className="h-12 w-12 text-white" />
                                    </div>
                                    <span className='underline-offset-4 underline decoration-4 decoration-yellow-400'>Sign up</span> for Free
                                </dt>
                                <dd className="mt-2 text-base leading-7 text-gray-600">
                                    Create an account to access our course catalog and start learning immediately.
                                </dd>
                            </motion.div>
                            <motion.div className="relative pl-16" variants={itemVariants}>
                                <dt className="text-base font-semibold leading-7 text-gray-900">
                                    <div className="absolute left-0 top-0 flex h-12 w-12 items-center justify-center rounded-lg">
                                        <img src={image2} alt="Choose" className="h-12 w-12 text-white" />
                                    </div>
                                    Choose Your Courses
                                </dt>
                                <dd className="mt-2 text-base leading-7 text-gray-600">
                                    Browse our extensive course offerings and select the ones that align with your career objectives.
                                </dd>
                            </motion.div>
                            <motion.div className="relative pl-16" variants={itemVariants}>
                                <dt className="text-base font-semibold leading-7 text-gray-900">
                                    <div className="absolute left-0 top-0 flex h-12 w-12 items-center justify-center rounded-lg">
                                        <img src={image3} alt="Learn" className="h-12 w-12 text-white" />
                                    </div>
                                    Learn at Your Own Pace
                                </dt>
                                <dd className="mt-2 text-base leading-7 text-gray-600">
                                    With our flexible learning options, you can complete courses on your schedule, without any deadlines.
                                </dd>
                            </motion.div>
                            <motion.div className="relative pl-16" variants={itemVariants}>
                                <dt className="text-base font-semibold leading-7 text-gray-900">
                                    <div className="absolute left-0 top-0 flex h-12 w-12 items-center justify-center rounded-lg">
                                        <img src={image4} alt="Forums" className="h-12 w-12 text-white" />
                                    </div>
                                    Forums & <span className=''>Reviews</span>
                                </dt>
                                <dd className="mt-2 text-base leading-7 text-gray-600">
                                    Engage with fellow learners and instructors in our vibrant online community.
                                </dd>
                            </motion.div>
                        </dl>
                    </motion.div>
                </div>
            </div>
        </section>
    )
}

export default IndividualAbout;
